import { companyIpWhitelistApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const COMPANY_IP_WHITELIST_ACTION_TYPE = createNamedActions('companyIpWhitelist', {
  GET_ENTRIES: 'GET_ENTRIES',
  ADD_ENTRY: 'ADD_ENTRY',
  UPDATE_ENTRY: 'UPDATE_ENTRY',
  REMOVE_ENTRY: 'REMOVE_ENTRY',
});

export const getCompanyIpWhitelistAction = catchAsyncActionError(
  ({ companyId }) =>
    async dispatch => {
      const { data } = await companyIpWhitelistApi.getEntries(companyId);

      return dispatch({
        type: COMPANY_IP_WHITELIST_ACTION_TYPE.GET_ENTRIES,
        payload: data,
      });
    },
);

export const addCompanyIpWhitelistEntryAction = catchAsyncActionError(
  ({ companyId, entry }) =>
    async dispatch => {
      const { data } = await companyIpWhitelistApi.createEntry(companyId, entry);

      return dispatch({
        type: COMPANY_IP_WHITELIST_ACTION_TYPE.ADD_ENTRY,
        payload: data,
      });
    },
);

export const updateCompanyIpWhitelistEntryAction = catchAsyncActionError(
  ({ companyId, id, entry }) =>
    async dispatch => {
      const { data } = await companyIpWhitelistApi.updateEntry(companyId, id, entry);

      return dispatch({
        type: COMPANY_IP_WHITELIST_ACTION_TYPE.UPDATE_ENTRY,
        payload: data,
      });
    },
);

export const deleteCompanyIpWhitelistEntryAction = catchAsyncActionError(
  ({ companyId, id }) =>
    async dispatch => {
      await companyIpWhitelistApi.deleteEntry(companyId, id);

      return dispatch({
        type: COMPANY_IP_WHITELIST_ACTION_TYPE.REMOVE_ENTRY,
        payload: id,
      });
    },
);
